import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { cn } from "@/lib/utils";

/** Markdown renderer for AI answers (GFM tables, lists, code). Styled via .prose-hh in index.css. */
export const Markdown = ({ children, className }) => (
  <div className={cn("prose-hh min-w-0 break-words", className)}>
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        a: ({ node, ...props }) => <a {...props} target="_blank" rel="noreferrer" />,
        table: ({ node, ...props }) => (
          <div className="overflow-x-auto">
            <table {...props} />
          </div>
        ),
      }}
    >
      {children || ""}
    </ReactMarkdown>
  </div>
);
